import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import { customSearchNumbers, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";
import { formattedNumber, unFormatNumber } from "./AddRemoveNumbers";


export default function AddNumbersStatic(props) {
    const { t, i18n } = useTranslation();
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [addNumbers, setAddNumbers] = useState([]);
    const [removeNumbers, setRemoveNumbers] = useState([]);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [prevaddednumber, setPrevAddedNumber] = useState([]);
    const [updatesourceadd, setUpdateSourceAdd] = useState(false);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)
        
    const navigate = useNavigate();

    const handleAdd = (number) => {
        const addList = addNumbers.includes(number) ? addNumbers.filter(num => num !== number) : [...addNumbers, number];
        const removeNum = (removeNumbers.includes(number)) ? removeNumbers.filter(removenum => removenum !== number) : removeNumbers;
        setRemoveNumbers(removeNum);
        setAddNumbers(addList);
    };

    // async function getFreePhoneNumber() {
    //     let updates = {}
    //     console.log(sessionStorage.getItem("admin_session"));
    //     updates = {
    //         "misc": ["free_dids"],
    //     };

    //     const response = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, updates);
    //     if (!response.json) {
    //         const message = `An error has occured: ${response.statusText}`;
    //         return;
    //     }
    //     const basicInfo = await response.json();
    //     if (!basicInfo) {
    //         window.alert(`info with id  not found`);
    //         navigate("/");
    //     }
    //     console.log("response data is :::::::::: " + basicInfo);

    //     setSourceNumber(basicInfo.misc.free_dids);

    // }

    useEffect(() => {
        if (props.sourceNumber.length > 0 && !updatesourcedel) {
            setSelectedNumbers(props.selectedNum);
            setPrevAddedNumber(props.selectedNum);
            // Filter out props.selectedNum from sourceNumber
            const updatedSourceNumber = props.sourceNumber.filter(num => !props.selectedNum.includes(num));
            setSourceNumber(updatedSourceNumber);
            if (props.removePHNum.length > 0) {
                setRemoveNumbers(props.removePHNum);
                setSourceNumber(prevSourceNumber => [...prevSourceNumber, ...props.removePHNum.filter(rmnum => !prevSourceNumber.includes(rmnum))]);
            }
            setUpdateSourceDel(true);
        }
        if(!dataLoaded){setDataLoaded(true)}
    }, [props, updatesourcedel]);

    // useEffect(() => {

    //     getFreePhoneNumber();

    // }, []);

    const handleDelete = (num) => {
        const number = unFormatNumber(num);
        const updateAddList = addNumbers.includes(number) ? addNumbers.filter(num => number !== num) : addNumbers;
        setAddNumbers(updateAddList);
    }

    async function setAddRemoveNumbers(e) {
        e.preventDefault();
        e.stopPropagation();
        props.setaddPHNum([...prevaddednumber, ...addNumbers]);
        props.setRemovePHNum(removeNumbers);
        props.setUpdateNumbersExecuted(false);
        props.onClose();
    }
    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        // Filter numbers based on current search
        const filteredNumbers = customSearchNumbers(sourceNumber, searchSourceQuery)
        if (filteredNumbers.length === 0) {
            return;}
        const updateNumbers = addNumbers.concat(filteredNumbers.filter(num => !(addNumbers.includes(num))));
        setAddNumbers(updateNumbers);
    }
    return (
        <div>
            <div>
                {/* // Show destination search only if user has selected or added at least one number */}
                {(selectedNumbers?.length > 0 || addNumbers?.length > 0) && (
                <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                    <input className='form-control' type='text' placeholder='Search'
                        value={searchDetinationQuery}
                        onChange={(e) => setSearchDetinationQuery(e.target.value)}
                    />
                    </MDBInputGroup>)}
                <div className="form-group row">
                    <div className="col-12">
                        <div className="form-outlines phoneNumberheight p-0">
                            <div className="chips chips-placeholder">
                                {selectedNumbers && selectedNumbers.length > 0 || addNumbers && addNumbers.length > 0 ? <>
                                {selectedNumbers && selectedNumbers.length > 0 && (
                                        customSearchNumbers(selectedNumbers, searchDetinationQuery)
                                        .map((phone) => (
                                            <MDBChip
                                                key={phone} className="m-chip d-inline py-2 px-3">
                                                {formattedNumber(phone)}
                                            </MDBChip>
                                        ))
                                )}
                                {addNumbers && addNumbers.length > 0 && (
                                            customSearchNumbers(addNumbers, searchDetinationQuery)
                                        .map((phone) => (
                                            <MDBChip
                                                onDelete={handleDelete} className="m-chip d-inline py-2 px-3"
                                                key={phone} closeIcon size="sm">
                                                {formattedNumber(phone)}
                                            </MDBChip>
                                        ))
                                )}
                                </> : <>
                                    <p className='m-1 text-secondary'>
                                        The selected Numbers will appear in this section
                                    </p>
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                <input className='form-control' ref={searchRef} type='text' placeholder='Search'
                    value={searchSourceQuery}
                    onChange={(e) => setSearchSourceQuery(e.target.value)} />
            </MDBInputGroup>
            <label className="selectall pt-2 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                {t("selectAll")}
            </label>
            <div className="phoneNumberheight">
                <div className="routing-numbers">
                    <div className="chips chips-placeholder">
                        {sourceNumber && sourceNumber.length > 0 && (
                                 customSearchNumbers(sourceNumber, searchSourceQuery).map(number => ( 
                                    <div
                                        className={addNumbers.includes(number) ? "numberadd-green" : "numberadd"}
                                        onClick={() => handleAdd(number)}
                                    >
                                        {formattedNumber(number)}
                                    </div>
                                ))
                        )}
                    </div>
                </div>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => setAddRemoveNumbers(e)}>{t("add")}</MDBBtn>
            </MDBModalFooter>
        </div>
    );
}

